<template>
  <div id="contenedor-main-listado-anticipos">
    <template v-if="!$vuetify.breakpoint.xs">
      <desktop
        :solo-lectura="soloLectura"
        :listadoAnticipos="listadoAnticipos"
        :es-contrato-financiado="esContratoFinanciado">
      </desktop>
    </template>
    <template v-else>
      <mobile :listadoAnticipos="listadoAnticipos"></mobile>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoAnticipos',
  props: {
    listadoAnticipos: {
      type: Array,
      required: true,
    },
    esContratoFinanciado: {
      type: Boolean,
      required: false,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
